import React from 'react';
import { HeroSection } from './components/HeroSection';
import { AhaMomentSection } from './components/AhaMomentSection';
import { ProblemSection } from './components/ProblemSection';
import { PatternRevealSection } from './components/PatternRevealSection';
import { MechanismSection } from './components/MechanismSection';
import { ProductIntroSection } from './components/ProductIntroSection';
import { FeaturesSection } from './components/FeaturesSection';
import { TransformationSection } from './components/TransformationSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { DecisionSection } from './components/DecisionSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
export function App() {
  return <div className="min-h-screen w-full bg-beige font-body text-charcoal selection:bg-gold/30" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <AhaMomentSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <PatternRevealSection data-id="element-5" />
        <MechanismSection data-id="element-6" />
        <ProductIntroSection data-id="element-7" />
        <FeaturesSection data-id="element-8" />
        <TransformationSection data-id="element-9" />
        <TestimonialsSection data-id="element-10" />
        <DecisionSection data-id="element-11" />
        <PricingSection data-id="element-12" />
        <GuaranteeSection data-id="element-13" />
        <FaqSection data-id="element-14" />
        <FinalCtaSection data-id="element-15" />
      </main>

      <footer className="bg-charcoal text-beige/40 py-8 text-center font-body text-sm" data-id="element-16">
        <div className="container mx-auto px-6" data-id="element-17">
          <p data-id="element-18">
            © {new Date().getFullYear()} El Origen de Tus Bloqueos. Todos los
            derechos reservados.
          </p>
          <p className="mt-2 text-xs" data-id="element-19">
            Este producto no sustituye la terapia psicológica profesional.
          </p>
        </div>
      </footer>
    </div>;
}